export default __webpack_public_path__ + "static/media/logo_sm.0bcf37dc.svg";